import React, { useState, useEffect } from 'react';
import { FaWhatsapp, FaTelegramPlane, FaInstagram, FaFacebookF, FaYoutube } from 'react-icons/fa';
import SoftAurora from './SoftAurora';
import StockLogo from './StockLogo';
import { Link } from 'react-router-dom';

const Footer = ({ showTicker = false }) => {
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const userAgentMatch = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const widthMatch = window.innerWidth <= 1024;
      setIsMobileDevice(userAgentMatch || widthMatch);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <footer className={showTicker ? "footer" : "dashboard-footer-new"} id="contact">
      {/* Soft Aurora Background */}
      <div className="aurora-bg-container">
        {!isMobileDevice && (
          <SoftAurora 
            color1="#8b5cf6" 
            color2="#0ea5e9" 
            brightness={0.8}
          />
        )}
      </div>

      {/* Stock Ticker (Only on MainPage) */}
      {showTicker && (
        <div className="stock-ticker" style={{ position: 'relative', zIndex: 1 }}>
          <div className="ticker-wrapper">
            <div className="ticker-content">
              <div className="ticker-item">
                <span className="ticker-symbol">NIFTY 50</span>
                <span className="ticker-price">19,745.00</span>
                <span className="ticker-change positive">+152.30</span>
              </div>
              <div className="ticker-item">
                <span className="ticker-symbol">SENSEX</span>
                <span className="ticker-price">66,230.00</span>
                <span className="ticker-change positive">+421.80</span>
              </div>
              <div className="ticker-item">
                <span className="ticker-symbol">BANK NIFTY</span>
                <span className="ticker-price">45,120.00</span>
                <span className="ticker-change negative">-89.50</span>
              </div>
              <div className="ticker-item">
                <span className="ticker-symbol">NIFTY IT</span>
                <span className="ticker-price">30,248.75</span>
                <span className="ticker-change positive">+724.30</span>
              </div>
              <div className="ticker-item">
                <StockLogo symbol="RELIANCE" className="ticker-logo" />
                <span className="ticker-symbol">RELIANCE</span>
                <span className="ticker-price">2,456.75</span>
                <span className="ticker-change positive">+84.50</span>
              </div>
              <div className="ticker-item">
                <StockLogo symbol="TCS" className="ticker-logo" />
                <span className="ticker-symbol">TCS</span>
                <span className="ticker-price">3,847.50</span>
                <span className="ticker-change positive">+192.25</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Main Footer Content */}
      <div className="dashboard-container" style={{ position: 'relative', zIndex: 1 }}>
        <div className="footer-top-row">
          <div className="footer-brand-section">
            <div className="footer-logo">
              <img src="/images/Final Font Stocks4U1.png" className="logo-text" alt="Stocks4U Logo" />
            </div>
            <p className="footer-subtitle">Your trusted partner for stock market analysis and trading insights.</p>
            <div className="footer-subscribe-box">
              <input type="email" placeholder="Email address" className="footer-email-input" />
              <button className="footer-subscribe-btn">Submit <span>→</span></button>
            </div>
          </div>
          
          <div className="footer-links-section">
            <div className="footer-link-group">
              <h4>Pages</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><a href="/#features">How It Works</a></li>
                <li><a href="/#pricing">Pricing</a></li>
                <li><a href="/#contact">Contact Us</a></li>
              </ul>
            </div>
            
            <div className="footer-link-group">
              <h4>Resources</h4>
              <ul>
                <li><Link to="/disclaimer">Disclaimer</Link></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><a href="#">Refund Policy</a></li>
                <li><Link to="/disclosure">Disclosure</Link></li>
                <li><Link to="/terms">Terms Of Use</Link></li>
              </ul>
            </div>
            
            <div className="footer-link-group contact-group">
              <h4>Contact</h4>
              <p>Email: support@stocks4u.com</p>
              <p>Phone: +91 1234567890</p>
              <div className="footer-social-icons">
                <a href="#" className="social-icon whatsapp"><FaWhatsapp /></a>
                <a href="#" className="social-icon telegram"><FaTelegramPlane /></a>
                <a href="#" className="social-icon instagram"><FaInstagram /></a>
                <a href="#" className="social-icon facebook"><FaFacebookF /></a>
                <a href="#" className="social-icon youtube"><FaYoutube /></a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-divider"></div>
        
        <div className="footer-bottom-row">
          <p>stocks4u©2026</p>
          <p>All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
